import { lazy } from "react";

const RELOAD_KEY = "neuracraft:chunk-reload";

// Retries a failed dynamic import once with a full page reload (e.g. a stale chunk after a deploy).
export default function lazyWithRetry(factory) {
  return lazy(() =>
    factory().then(
      (mod) => {
        sessionStorage.removeItem(RELOAD_KEY);
        return mod;
      },
      (err) => {
        if (!sessionStorage.getItem(RELOAD_KEY)) {
          sessionStorage.setItem(RELOAD_KEY, "1");
          window.location.reload();
          return new Promise(() => {});
        }
        throw err;
      }
    )
  );
}
